// extracted by mini-css-extract-plugin
export default {"zoomModal":"H2-z"};